const LAYOUT_SIGNATURE_PART_SEPARATOR_CHAR_CODE = 124;

export const LAYOUT_SIGNATURE_EMPTY = "0";

const accumulateStringHash = ({
  hash,
  value,
}: {
  hash: number;
  value: string;
}): number => {
  let nextHash = hash;

  for (let index = 0; index < value.length; index++) {
    // eslint-disable-next-line no-bitwise
    nextHash = (nextHash << 5) - nextHash + value.charCodeAt(index);
    // eslint-disable-next-line no-bitwise
    nextHash |= 0;
  }

  return nextHash;
};

const hashOrderedParts = (parts: readonly string[]): number => {
  let hash = 0;

  for (const part of parts) {
    hash = accumulateStringHash({ hash, value: part });
    hash = accumulateStringHash({
      hash,
      value: String.fromCharCode(LAYOUT_SIGNATURE_PART_SEPARATOR_CHAR_CODE),
    });
  }

  return hash;
};

/** Compact react-window / memo dependency key from string parts (avoids huge join strings). */
export const buildPartsLayoutSignature = (
  parts: readonly string[],
  { sort = false }: { sort?: boolean } = {},
): string => {
  if (parts.length === 0) {
    return LAYOUT_SIGNATURE_EMPTY;
  }

  const orderedParts = sort ? [...parts].sort() : parts;

  return `${parts.length}:${hashOrderedParts(orderedParts)}`;
};
